// extracted by mini-css-extract-plugin
module.exports = {"video":"Videos-module--video--3h4IQ","playerWrapper":"Videos-module--playerWrapper--2i3L4","player":"Videos-module--player--3bUOo"};